/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const spacingBase = '8px' as const;

export const spacingSpacing01 = '2px' as const;

export const spacingSpacing02 = '4px' as const;

export const spacingSpacing03 = '8px' as const;

export const spacingSpacing04 = '12px' as const;

export const spacingSpacing05 = '16px' as const;

export const spacingSpacing06 = '20px' as const;

export const spacingSpacing07 = '24px' as const;

export const spacingSpacing08 = '32px' as const;

export const spacingSpacing09 = '40px' as const;

export const spacingSpacing10 = '48px' as const;

export const spacingSpacing11 = '56px' as const;

export const spacingSpacing12 = '64px' as const;

export const spacingSpacing13 = '80px' as const;

export const spacingSpacing14 = '96px' as const;

export const spacingSpacing15 = '120px' as const;

export const spacingSpacing16 = '160px' as const;

export const spacingSpacing17 = '192px' as const;

export const spacingSpacing18 = '200px' as const;

export const spacingSpacing00 = '0px' as const;
